import { getApiB2bAnnualUpdates } from '/api/sdk.gen';
import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';

import type { AppDispatch, RootState } from '/business/shared/state/store';

const getAnnualUpdates = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const { applications } = getState?.() || {};

    if (applications?.fetchingAnnualUpdates) {
      return applications?.annualUpdates || null;
    }

    dispatch({ type: 'GET_ANNUAL_UPDATES_STARTED' });
    const { data: annualUpdates } = await getApiB2bAnnualUpdates();
    dispatch({ type: 'GET_ANNUAL_UPDATES_FULFILLED', annualUpdates });
    return annualUpdates;
  } catch (error) {
    if (error instanceof ValidationError) {
      dispatch({ type: 'GET_ANNUAL_UPDATES_REJECTED', error });
    } else {
      dispatch({
        type: 'GET_ANNUAL_UPDATES_REJECTED',
        error: normaliseError(toNormaliseErrorInput(error), 'GET_ANNUAL_UPDATES'),
      });
    }
    throw error;
  }
};

export default getAnnualUpdates;
